import { CountryCode } from "libphonenumber-js";

export const FAVORITE_COUNTRIES: CountryCode[] = ["MX", "BR", "IN", "NG", "US"];
